import { create } from "zustand";
import api from "../api/axios";

const useAttendanceStore = create((set) => ({
  attendanceData: [],
  loading: false,

  fetchAttendance: async ({
    selectedCompany,
    permissions,
  }) => {
    try {
      set({ loading: true });

      let apiUrl = "";

      const hasViewAllManagedPermission = permissions.some(
        (permission) =>
          permission.name ===
          "view_attendances_managed_employee"
      );

      const hasViewPerGroupPermission = permissions.some(
        (permission) =>
          permission.name ===
          "view_attendances_per_group"
      );

      if (hasViewAllManagedPermission) {
        apiUrl = "/attendances/managed";
      } else if (hasViewPerGroupPermission) {
        apiUrl = `/attendances?company=${selectedCompany}`;
      } else {
        console.log(
          "User does not have required permissions."
        );

        set({ loading: false });
        return [];
      }

      const response = await api.get(apiUrl);

      const dataObject = response.data?.data || {};

      const attendanceData = Object.keys(
        dataObject
      ).map((key) => dataObject[key]);

      set({
        attendanceData,
        loading: false,
      });

      return attendanceData;
    } catch (error) {
      console.log(error);

      set({
        loading: false,
      });

      return [];
    }
  },
}));

export default useAttendanceStore;